function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M204.782 386.403C203.517 382.839 201.421 379.626 198.666 377.029C195.911 374.432 192.577 372.525 188.938 371.467C185.299 370.408 181.459 370.227 177.737 370.94C174.014 371.652 170.514 373.237 167.526 375.564C165.358 372.543 162.59 369.997 159.395 368.086C156.2 366.175 152.646 364.938 148.952 364.452C147.583 359.809 145.201 355.527 141.975 351.911C138.75 348.296 134.763 345.438 130.298 343.542C125.834 341.647 121.005 340.76 116.157 340.947C111.308 341.134 106.562 342.389 102.258 344.622C100.306 341.639 97.6484 339.179 94.5196 337.46C91.3908 335.742 87.8865 334.816 84.3148 334.765C80.7432 334.714 77.2137 335.54 74.037 337.169C70.8602 338.797 68.1336 341.18 66.0969 344.107C63.495 342.423 60.5322 341.374 57.4484 341.044C54.3645 340.714 51.246 341.113 48.3453 342.208C45.4447 343.303 42.8432 345.064 40.7515 347.348C38.6597 349.632 37.1364 352.376 36.3049 355.356H35.3929C29.2922 355.351 23.4358 357.746 19.0936 362.02C14.7514 366.294 12.2737 372.103 12.1977 378.187C11.6014 378.072 10.996 378.011 10.3889 378.005C8.04716 378.009 5.78784 378.867 4.03562 380.417C2.2834 381.966 1.15896 384.1 0.873657 386.418L204.782 386.403Z",
  fill: "#009245"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M79.792 339.892C95.2504 339.892 108.277 351.399 112.442 367.18C116.386 367.833 120.144 369.322 123.461 371.548C126.778 373.773 129.578 376.684 131.67 380.082C135.845 376.336 141.254 374.248 146.87 374.215C151.06 374.298 155.155 375.469 158.753 377.611C162.352 379.754 165.328 382.795 167.39 386.434H204.751C203.487 382.869 201.39 379.656 198.636 377.059C195.881 374.462 192.546 372.556 188.907 371.497C185.268 370.438 181.429 370.257 177.706 370.97C173.983 371.682 170.484 373.267 167.496 375.594C165.327 372.573 162.56 370.028 159.365 368.116C156.17 366.205 152.615 364.968 148.922 364.482C147.553 359.839 145.17 355.557 141.945 351.942C138.72 348.327 134.732 345.468 130.268 343.573C125.804 341.677 120.974 340.791 116.126 340.977C111.278 341.164 106.531 342.419 102.227 344.653C100.366 341.809 97.863 339.44 94.9185 337.735C91.9741 336.031 88.6701 335.037 85.2715 334.836C81.8729 334.634 78.4741 335.229 75.3476 336.573C72.221 337.917 69.4537 339.973 67.2672 342.576C71.2061 340.812 75.4742 339.897 79.792 339.892Z",
  fill: "#009245"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M152.478 120.83V215.126H149.089V202.027L135.743 191.749L149.317 120.83H152.478Z",
  fill: "#CCCCCC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M152.478 120.83H149.317V215.126H152.478V120.83Z",
  fill: "#B3B3B3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M68.9088 261.288L150.791 214.14L152.478 217.066L141.124 223.615L138.859 240.276L70.4896 264.017L68.9088 261.288Z",
  fill: "#CCCCCC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M150.789 214.144L68.9119 261.292L70.4927 264.022L152.37 216.875L150.789 214.144Z",
  fill: "#B3B3B3"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M232.658 263.243L150.791 216.096L152.478 213.17L163.848 219.704L179.443 213.322L234.239 260.515L232.658 263.243Z",
  fill: "#CCCCCC"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M152.369 213.359L150.788 216.09L232.666 263.238L234.247 260.507L152.369 213.359Z",
  fill: "#B3B3B3"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M159.577 396.182H142.006L148.298 217.93H153.269L159.577 396.182Z",
  fill: "#CCCCCC"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M159.577 396.182H150.791V217.93H153.269L159.577 396.182Z",
  fill: "#B3B3B3"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M158.68 215.687C158.68 217.255 158.214 218.788 157.34 220.091C156.467 221.395 155.225 222.412 153.773 223.012C152.32 223.612 150.722 223.769 149.18 223.463C147.637 223.157 146.221 222.402 145.109 221.293C143.997 220.184 143.24 218.771 142.934 217.233C142.627 215.695 142.784 214.101 143.386 212.652C143.988 211.204 145.007 209.965 146.314 209.094C147.621 208.223 149.158 207.758 150.73 207.758C152.839 207.758 154.861 208.593 156.352 210.08C157.843 211.567 158.68 213.584 158.68 215.687Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M153.862 208.364C154.394 209.444 154.67 210.632 154.667 211.836C154.673 213.144 154.352 214.434 153.735 215.589C153.118 216.744 152.224 217.728 151.132 218.453C150.04 219.179 148.785 219.623 147.479 219.746C146.172 219.869 144.856 219.667 143.647 219.158C144.212 220.31 145.047 221.308 146.083 222.067C147.119 222.826 148.323 223.323 149.594 223.516C150.865 223.708 152.163 223.591 153.378 223.174C154.593 222.756 155.689 222.051 156.571 221.119C157.453 220.187 158.095 219.055 158.443 217.821C158.791 216.587 158.833 215.288 158.567 214.034C158.3 212.78 157.733 211.609 156.914 210.622C156.094 209.634 155.047 208.86 153.862 208.364Z",
  fill: "#A1BFCA"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M150.457 211.654C150.46 211.999 150.36 212.338 150.17 212.627C149.979 212.915 149.708 213.141 149.388 213.275C149.069 213.41 148.717 213.446 148.377 213.381C148.037 213.315 147.724 213.151 147.478 212.907C147.232 212.664 147.064 212.354 146.996 212.015C146.927 211.676 146.961 211.325 147.093 211.006C147.224 210.686 147.448 210.413 147.736 210.221C148.024 210.028 148.362 209.926 148.709 209.926C149.17 209.926 149.612 210.107 149.94 210.431C150.267 210.755 150.453 211.194 150.457 211.654Z",
  fill: "#58C662"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M212.306 8.47961V141.236H207.533V122.816L188.73 108.339L207.837 8.47961H212.306Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M212.306 8.47961H207.852V141.251H212.306V8.47961Z",
  fill: "#A1BFCA"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M94.6273 206.242L209.919 139.871L212.306 143.995L196.3 153.197L193.123 176.68L96.8617 210.092L94.6273 206.242Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M209.914 139.855L94.6269 206.241L96.8537 210.088L212.14 143.702L209.914 139.855Z",
  fill: "#A1BFCA"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M325.196 209.001L209.919 142.615L212.306 138.492L228.296 147.694L250.275 138.719L327.43 205.15L325.196 209.001Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M212.14 138.785L209.913 142.631L325.2 209.017L327.426 205.17L212.14 138.785Z",
  fill: "#A1BFCA"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M222.292 396.182H197.531L206.423 145.208H213.415L222.292 396.182Z",
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M222.292 396.182H209.919V145.208H213.415L222.292 396.182Z",
  fill: "#A1BFCA"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M217.839 149.935C222.214 145.571 222.214 138.497 217.839 134.134C213.464 129.77 206.371 129.77 201.997 134.134C197.622 138.497 197.622 145.571 201.997 149.935C206.371 154.298 213.464 154.298 217.839 149.935Z",
  fill: "white"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M214.236 131.73C215.072 133.432 215.46 135.317 215.364 137.21C215.267 139.102 214.689 140.938 213.684 142.546C212.679 144.154 211.28 145.48 209.618 146.399C207.957 147.318 206.089 147.8 204.189 147.8C202.702 147.796 201.231 147.502 199.857 146.936C200.646 148.561 201.819 149.971 203.276 151.045C204.732 152.118 206.427 152.823 208.217 153.099C210.006 153.375 211.836 153.213 213.549 152.628C215.263 152.043 216.808 151.052 218.052 149.74C219.296 148.428 220.203 146.834 220.694 145.096C221.184 143.357 221.245 141.526 220.869 139.759C220.494 137.993 219.694 136.343 218.539 134.952C217.384 133.562 215.907 132.472 214.236 131.776V131.73Z",
  fill: "#A1BFCA"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M209.433 136.369C209.433 136.853 209.289 137.325 209.019 137.727C208.75 138.129 208.367 138.441 207.919 138.626C207.471 138.81 206.978 138.858 206.503 138.762C206.027 138.667 205.591 138.433 205.25 138.09C204.908 137.747 204.676 137.311 204.584 136.836C204.491 136.362 204.542 135.871 204.729 135.425C204.917 134.979 205.233 134.599 205.637 134.333C206.042 134.066 206.516 133.926 207.001 133.929C207.647 133.933 208.266 134.192 208.721 134.649C209.177 135.106 209.433 135.725 209.433 136.369Z",
  fill: "#58C662"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M81.9049 106.156C93.2293 106.156 102.41 96.9994 102.41 85.7048C102.41 74.4101 93.2293 65.2539 81.9049 65.2539C70.5804 65.2539 61.4001 74.4101 61.4001 85.7048C61.4001 96.9994 70.5804 106.156 81.9049 106.156Z",
  fill: "white"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M86.5257 76.927C83.9498 78.6026 82.0497 81.1313 81.1601 84.0673C80.3807 87.388 80.3807 90.8433 81.1601 94.1639C81.2817 93.7849 81.3881 93.4059 81.4945 93.0269C83.8809 85.0982 86.0545 78.8068 86.0545 78.8068C86.0545 78.8068 84.3521 85.3863 81.9657 93.315C81.8593 93.694 81.7377 94.073 81.6313 94.452C84.0338 92.7579 85.8036 90.3154 86.6625 87.5087C87.4565 84.0203 87.4096 80.3938 86.5257 76.927Z",
  fill: "#29ABE2"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M79.8528 88.2818C78.6368 84.5524 77.8616 81.9904 77.8616 81.9904C77.8616 81.9904 78.7128 84.1279 79.8984 87.3873C79.9802 86.1912 80.1891 85.0072 80.5216 83.8551C80.5216 83.7338 80.5976 83.6125 80.6432 83.4912C79.7065 82.3121 78.588 81.2887 77.3296 80.4592C76.4595 83.107 76.4118 85.9552 77.1928 88.6305C77.8488 90.356 78.8882 91.9109 80.2328 93.1785C79.9445 91.5627 79.8173 89.9225 79.8528 88.2818Z",
  fill: "#29ABE2"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6462 42.0219C104.907 33.3545 103.749 20.4574 95.0583 13.2154C86.368 5.97348 73.4369 7.12905 66.1759 15.7965C58.9148 24.4639 60.0734 37.361 68.7637 44.603C77.454 51.8449 90.3851 50.6893 97.6462 42.0219Z",
  fill: "white"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M90.7057 30.4919V27.4599H88.1825C88.0261 26.8009 87.7644 26.1713 87.4073 25.5952L89.1857 23.8215L87.0729 21.6991L85.2793 23.4728C84.6999 23.1203 84.0692 22.8595 83.4097 22.6997V20.1831H80.3697V22.6997C79.7053 22.8594 79.0696 23.1202 78.4849 23.4728L76.7065 21.6991L74.5785 23.8215L76.3569 25.5952C76.006 26.1744 75.7446 26.803 75.5817 27.4599H73.1041V30.4919H75.6273C75.7902 31.1488 76.0516 31.7774 76.4025 32.3566L74.6241 34.1455L76.7521 36.2527L78.5305 34.479C79.1152 34.8317 79.7509 35.0924 80.4153 35.2521V37.7687H83.4553V35.1915C84.1148 35.0317 84.7455 34.7709 85.3249 34.4183L87.1185 36.1921L89.2313 34.0848L87.4529 32.296C87.81 31.7199 88.0717 31.0903 88.2281 30.4313L90.7057 30.4919ZM81.9049 32.4324C81.2231 32.4324 80.5566 32.2309 79.9895 31.8535C79.4224 31.476 78.9802 30.9394 78.7186 30.3115C78.457 29.6835 78.3878 28.9924 78.5197 28.3253C78.6516 27.6581 78.9787 27.0449 79.4597 26.563C79.9408 26.0812 80.5541 25.7522 81.2225 25.6177C81.8908 25.4833 82.584 25.5492 83.2148 25.8074C83.8455 26.0655 84.3854 26.5042 84.7664 27.0682C85.1473 27.6321 85.3523 28.2959 85.3553 28.9759C85.3433 29.8807 84.9745 30.7444 84.3287 31.3799C83.6829 32.0155 82.8121 32.3718 81.9049 32.3718V32.4324Z",
  fill: "#29ABE2"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M81.9049 162.915C93.2293 162.915 102.41 153.758 102.41 142.464C102.41 131.169 93.2293 122.013 81.9049 122.013C70.5804 122.013 61.4001 131.169 61.4001 142.464C61.4001 153.758 70.5804 162.915 81.9049 162.915Z",
  fill: "white"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M83.3488 148.573V151.241H81.0232V148.558C79.4136 148.339 77.8918 147.695 76.6152 146.693L77.8616 144.192C79.1109 145.256 80.6631 145.903 82.3 146.042C83.2424 146.042 83.82 145.693 83.82 145.056C83.82 142.979 77.3752 144.222 77.3752 139.902C77.4088 138.949 77.8014 138.043 78.4747 137.366C79.1481 136.689 80.0527 136.29 81.008 136.248V133.686H83.3336V136.233C84.6934 136.381 86.0026 136.831 87.164 137.552L85.9632 140.084C84.7607 139.356 83.4105 138.906 82.0112 138.765C81.236 138.765 80.7344 139.053 80.7344 139.599C80.7344 141.63 87.1792 140.478 87.1792 144.874C87.24 147.027 85.5528 148.27 83.3488 148.573Z",
  fill: "#29ABE2"
});

function SvgLeftElements(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 397,
    viewBox: "0 0 328 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ref3)), _ref4, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ref5), _ref6, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ref7), _ref8, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ref9), _ref10, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ref11), _ref12, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ref13), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _ref14), _ref15, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ref16), _ref17, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ref18), _ref19, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ref20), _ref21, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ref22), _ref23, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ref24), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _ref25), _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftElements);
export default __webpack_public_path__ + "static/media/left_elements.007ebc67.svg";
export { ForwardRef as ReactComponent };